import { IconSend } from "@tabler/icons-react";
import { useRef, type FC, type FormEvent, type KeyboardEvent } from "react";
import { useAutoResizeTextarea } from "../hooks/useAutoResizeTextarea.js";

export interface ChatComposerProps {
  text: string;
  onTextChange: (text: string) => void;
  canSend?: boolean;
  onSend: () => void;
}

// TODO: Reconcile with UserMessageForm by adding a size prop for smaller size?
export const ChatComposer: FC<ChatComposerProps> = (props) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useAutoResizeTextarea({ textareaRef, value: props.text });

  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      props.onSend();
      event.currentTarget.blur();
    }
  };

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    props.onSend();
  };

  return (
    <form className="relative" onSubmit={onSubmit}>
      <textarea
        ref={textareaRef}
        name="message"
        aria-label="Your message"
        placeholder="Ask anything..."
        value={props.text}
        onKeyDown={onKeyDown}
        onChange={(event) => props.onTextChange(event.target.value)}
        rows={1}
        className="block w-full resize-none overflow-hidden rounded-2xl border-none py-2 pr-10 pl-3 text-xs text-foreground placeholder-gray-400 outline outline-1 outline-gray-300 transition-shadow duration-150 focus:outline-2 focus:outline-offset-0 focus:outline-indigo-600"
      />

      <button
        type="submit"
        aria-label="Send message"
        disabled={!props.canSend}
        className="absolute right-1 bottom-1 flex size-6 items-center justify-center rounded-full bg-primary text-primary-foreground transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-disabled"
      >
        <IconSend className="size-3.5" />
      </button>
    </form>
  );
};
